import http from 'axios'
import urls from './oktaFederations.urls'

export default {
  getFederations: ({ state, rootState, commit }) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .get(urls.federations)
      .then(response => {
        commit('setFederations', response.data)
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  addFederation: ({ state, rootState, commit, dispatch }, data) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .post(urls.federations, data)
      .then(response => {
        dispatch('getFederations')
        commit('global/setShowLoadingSpinner', false, { root: true })
        return response
      }, error => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
        throw error
      })
  },
  updateFederation: ({ state, rootState, commit, dispatch }, data) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .put(urls.changeFederations(data.federationId), data)
      .then(response => {
        dispatch('getFederations')
        commit('global/setShowLoadingSpinner', false, { root: true })
        return response
      }, error => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
        throw error
      })
  },
  deleteFederation: ({ state, rootState, commit, dispatch }, federationId) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .delete(urls.changeFederations(federationId))
      .then(response => {
        dispatch('getFederations')
        commit('global/setShowLoadingSpinner', false, { root: true })
        return response
      }, error => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
        throw error
      })
  },
  getFederationSsoGroups: ({ state, rootState, commit }, federationId) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .get(urls.federationSsoGroups(federationId))
      .then(response => {
        commit('setFederationSsoGroups', response.data)
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  addFederationSsoGroup: ({ state, rootState, commit, dispatch }, data) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .post(urls.federationSsoGroups(data.federationId), { [data.roleName]: data.userGroupId })
      .then(response => {
        dispatch('getFederationSsoGroups', data.federationId)
        commit('global/setShowLoadingSpinner', false, { root: true })
        return response
      }, error => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
        throw error
      })
  },
  deleteFederationSsoGroup: ({ state, rootState, commit, dispatch }, data) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .delete(urls.changeFederationSsoGroups(data.federationId, data.roleName, data.userGroupId))
      .then(response => {
        dispatch('getFederationSsoGroups', data.federationId)
        commit('global/setShowLoadingSpinner', false, { root: true })
        return response
      }, error => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
        throw error
      })
  }
}
